import dayjs from 'dayjs';

/**
 * オブジェクトからURLのクエリを作成
 * オブジェクトのキーの値がnullまたはundefinedの場合、パラメータから除外する
 * @param arg オブジェクト
 * @param excludeFunc 特定のキーで、 null 、 undefined 以外でも除外したい場合に設定（ false を返却したら除外される）
 */
export function toQuery(arg: object, excludeFunc?: (key: string, value: string | number | dayjs.Dayjs | boolean | undefined | null) => boolean): string {
  const res: { [key:string]: string | number | dayjs.Dayjs | boolean | undefined | null } = {};
  const newArgs = Object.entries(arg).reduce((acc, [key, value]) => {
    const val = value as string | number | dayjs.Dayjs | boolean | undefined | null;
    if (val === null || val === undefined || !(excludeFunc?.(key, val) ?? true)) {
      return acc;
    }
    acc[key] = val;
    return acc;
  }, res);

  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  return new URLSearchParams(newArgs as any).toString();
}
